import { render, staticRenderFns } from "./TfaSettings.vue?vue&type=template&id=2685d9e9"
import script from "./TfaSettings.vue?vue&type=script&lang=js"
export * from "./TfaSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports